import { render, staticRenderFns } from "./Wap_SZR7_Produce.vue?vue&type=template&id=56a58960&scoped=true&"
import script from "./Wap_SZR7_Produce.vue?vue&type=script&lang=js&"
export * from "./Wap_SZR7_Produce.vue?vue&type=script&lang=js&"
import style0 from "./Wap_SZR7_Produce.vue?vue&type=style&index=0&id=56a58960&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a58960",
  null
  
)

export default component.exports